import { ActionTree } from "vuex";
import { baseApiLogs } from "@/config/http-logs";
import { IRootState } from "@/store";
import { ILogsState } from "@/store/modules/logs/state";
import { LogsMutations } from "@/store/modules/logs/mutations";

export enum LogsActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_LOGS",
}

export const actions: ActionTree<ILogsState, IRootState> = {
  async [LogsActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApiLogs.get(
        "/api/logs/user-logs/get-user-logs",
        {
          params: params,
        }
      );
      commit(LogsMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch job data provider error: ", error);
    }
  },
};
